import { Card, CardBody, Col } from "reactstrap";
import { Btn, H3, H5, SVG } from "../../../../../AbstractElements";
import { ecommerceRevenueData } from "../../../../../Data/Dashboard/EcommerceDashboard/EcommerceDashboard";

const EcommerceRevenue = () => {
  return (
    <Col xl="12" lg="6">
      <Card>
        <CardBody className="revenue-ecommerce">
          <div className="d-flex">
            {ecommerceRevenueData.map((data, i) => (
              <div className="flex-grow-1 ecommerce" key={i}>
                <H5>{data.title}</H5>
                <H3>{data.amount}</H3>
                <Btn className={`bg-light-${data.color} d-flex gap-1`} >
                  <span className={`bg-light-${data.color}`}>
                    <SVG className={`fill-${data.color}`} iconId={data.icon}/>
                  </span>
                  <span className={`font-${data.color} f-w-600`}>{data.percentage}</span>
                </Btn>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default EcommerceRevenue;
